import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { DeleteSellersContainerProps } from "../../../../interfaces/containers";
import Delete from "../../../../pages/Profile/Sellers/Delete";
import { 
    getSellers,
    deleteSeller, 
    cleanDeleteSeller
} from "../../../../actions/profile";

function mapStateToProps(state: DeleteSellersContainerProps) {
    return {
        user: state.auth.user,
        sellers: state.profile.sellers,
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getSellers,
        deleteSeller, 
        cleanDeleteSeller,
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Delete);